export default "__VITE_ASSET__r6JepuQH__"